/* eslint-disable no-bitwise */
const crc_table_8 = [
  0x00,
  0x07,
  0x0e,
  0x09,
  0x1c,
  0x1b,
  0x12,
  0x15,
  0x38,
  0x3f,
  0x36,
  0x31,
  0x24,
  0x23,
  0x2a,
  0x2d,
  0x70,
  0x77,
  0x7e,
  0x79,
  0x6c,
  0x6b,
  0x62,
  0x65,
  0x48,
  0x4f,
  0x46,
  0x41,
  0x54,
  0x53,
  0x5a,
  0x5d,
  0xe0,
  0xe7,
  0xee,
  0xe9,
  0xfc,
  0xfb,
  0xf2,
  0xf5,
  0xd8,
  0xdf,
  0xd6,
  0xd1,
  0xc4,
  0xc3,
  0xca,
  0xcd,
  0x90,
  0x97,
  0x9e,
  0x99,
  0x8c,
  0x8b,
  0x82,
  0x85,
  0xa8,
  0xaf,
  0xa6,
  0xa1,
  0xb4,
  0xb3,
  0xba,
  0xbd,
  0xc7,
  0xc0,
  0xc9,
  0xce,
  0xdb,
  0xdc,
  0xd5,
  0xd2,
  0xff,
  0xf8,
  0xf1,
  0xf6,
  0xe3,
  0xe4,
  0xed,
  0xea,
  0xb7,
  0xb0,
  0xb9,
  0xbe,
  0xab,
  0xac,
  0xa5,
  0xa2,
  0x8f,
  0x88,
  0x81,
  0x86,
  0x93,
  0x94,
  0x9d,
  0x9a,
  0x27,
  0x20,
  0x29,
  0x2e,
  0x3b,
  0x3c,
  0x35,
  0x32,
  0x1f,
  0x18,
  0x11,
  0x16,
  0x03,
  0x04,
  0x0d,
  0x0a,
  0x57,
  0x50,
  0x59,
  0x5e,
  0x4b,
  0x4c,
  0x45,
  0x42,
  0x6f,
  0x68,
  0x61,
  0x66,
  0x73,
  0x74,
  0x7d,
  0x7a,
  0x89,
  0x8e,
  0x87,
  0x80,
  0x95,
  0x92,
  0x9b,
  0x9c,
  0xb1,
  0xb6,
  0xbf,
  0xb8,
  0xad,
  0xaa,
  0xa3,
  0xa4,
  0xf9,
  0xfe,
  0xf7,
  0xf0,
  0xe5,
  0xe2,
  0xeb,
  0xec,
  0xc1,
  0xc6,
  0xcf,
  0xc8,
  0xdd,
  0xda,
  0xd3,
  0xd4,
  0x69,
  0x6e,
  0x67,
  0x60,
  0x75,
  0x72,
  0x7b,
  0x7c,
  0x51,
  0x56,
  0x5f,
  0x58,
  0x4d,
  0x4a,
  0x43,
  0x44,
  0x19,
  0x1e,
  0x17,
  0x10,
  0x05,
  0x02,
  0x0b,
  0x0c,
  0x21,
  0x26,
  0x2f,
  0x28,
  0x3d,
  0x3a,
  0x33,
  0x34,
  0x4e,
  0x49,
  0x40,
  0x47,
  0x52,
  0x55,
  0x5c,
  0x5b,
  0x76,
  0x71,
  0x78,
  0x7f,
  0x6a,
  0x6d,
  0x64,
  0x63,
  0x3e,
  0x39,
  0x30,
  0x37,
  0x22,
  0x25,
  0x2c,
  0x2b,
  0x06,
  0x01,
  0x08,
  0x0f,
  0x1a,
  0x1d,
  0x14,
  0x13,
  0xae,
  0xa9,
  0xa0,
  0xa7,
  0xb2,
  0xb5,
  0xbc,
  0xbb,
  0x96,
  0x91,
  0x98,
  0x9f,
  0x8a,
  0x8d,
  0x84,
  0x83,
  0xde,
  0xd9,
  0xd0,
  0xd7,
  0xc2,
  0xc5,
  0xcc,
  0xcb,
  0xe6,
  0xe1,
  0xe8,
  0xef,
  0xfa,
  0xfd,
  0xf4,
  0xf3,
  0x00,
  0x15,
  0x2a,
  0x3f,
  0x54,
  0x41,
  0x7e,
  0x6b,
  0xa8,
  0xbd,
  0x82,
  0x97,
  0xfc,
  0xe9,
  0xd6,
  0xc3,
  0x57,
  0x42,
  0x7d,
  0x68,
  0x03,
  0x16,
  0x29,
  0x3c,
  0xff,
  0xea,
  0xd5,
  0xc0,
  0xab,
  0xbe,
  0x81,
  0x94,
  0xae,
  0xbb,
  0x84,
  0x91,
  0xfa,
  0xef,
  0xd0,
  0xc5,
  0x06,
  0x13,
  0x2c,
  0x39,
  0x52,
  0x47,
  0x78,
  0x6d,
  0xf9,
  0xec,
  0xd3,
  0xc6,
  0xad,
  0xb8,
  0x87,
  0x92,
  0x51,
  0x44,
  0x7b,
  0x6e,
  0x05,
  0x10,
  0x2f,
  0x3a,
  0x5b,
  0x4e,
  0x71,
  0x64,
  0x0f,
  0x1a,
  0x25,
  0x30,
  0xf3,
  0xe6,
  0xd9,
  0xcc,
  0xa7,
  0xb2,
  0x8d,
  0x98,
  0x0c,
  0x19,
  0x26,
  0x33,
  0x58,
  0x4d,
  0x72,
  0x67,
  0xa4,
  0xb1,
  0x8e,
  0x9b,
  0xf0,
  0xe5,
  0xda,
  0xcf,
  0xf5,
  0xe0,
  0xdf,
  0xca,
  0xa1,
  0xb4,
  0x8b,
  0x9e,
  0x5d,
  0x48,
  0x77,
  0x62,
  0x09,
  0x1c,
  0x23,
  0x36,
  0xa2,
  0xb7,
  0x88,
  0x9d,
  0xf6,
  0xe3,
  0xdc,
  0xc9,
  0x0a,
  0x1f,
  0x20,
  0x35,
  0x5e,
  0x4b,
  0x74,
  0x61,
  0xb6,
  0xa3,
  0x9c,
  0x89,
  0xe2,
  0xf7,
  0xc8,
  0xdd,
  0x1e,
  0x0b,
  0x34,
  0x21,
  0x4a,
  0x5f,
  0x60,
  0x75,
  0xe1,
  0xf4,
  0xcb,
  0xde,
  0xb5,
  0xa0,
  0x9f,
  0x8a,
  0x49,
  0x5c,
  0x63,
  0x76,
  0x1d,
  0x08,
  0x37,
  0x22,
  0x18,
  0x0d,
  0x32,
  0x27,
  0x4c,
  0x59,
  0x66,
  0x73,
  0xb0,
  0xa5,
  0x9a,
  0x8f,
  0xe4,
  0xf1,
  0xce,
  0xdb,
  0x4f,
  0x5a,
  0x65,
  0x70,
  0x1b,
  0x0e,
  0x31,
  0x24,
  0xe7,
  0xf2,
  0xcd,
  0xd8,
  0xb3,
  0xa6,
  0x99,
  0x8c,
  0xed,
  0xf8,
  0xc7,
  0xd2,
  0xb9,
  0xac,
  0x93,
  0x86,
  0x45,
  0x50,
  0x6f,
  0x7a,
  0x11,
  0x04,
  0x3b,
  0x2e,
  0xba,
  0xaf,
  0x90,
  0x85,
  0xee,
  0xfb,
  0xc4,
  0xd1,
  0x12,
  0x07,
  0x38,
  0x2d,
  0x46,
  0x53,
  0x6c,
  0x79,
  0x43,
  0x56,
  0x69,
  0x7c,
  0x17,
  0x02,
  0x3d,
  0x28,
  0xeb,
  0xfe,
  0xc1,
  0xd4,
  0xbf,
  0xaa,
  0x95,
  0x80,
  0x14,
  0x01,
  0x3e,
  0x2b,
  0x40,
  0x55,
  0x6a,
  0x7f,
  0xbc,
  0xa9,
  0x96,
  0x83,
  0xe8,
  0xfd,
  0xc2,
  0xd7,
  0x00,
  0x6b,
  0xd6,
  0xbd,
  0xab,
  0xc0,
  0x7d,
  0x16,
  0x51,
  0x3a,
  0x87,
  0xec,
  0xfa,
  0x91,
  0x2c,
  0x47,
  0xa2,
  0xc9,
  0x74,
  0x1f,
  0x09,
  0x62,
  0xdf,
  0xb4,
  0xf3,
  0x98,
  0x25,
  0x4e,
  0x58,
  0x33,
  0x8e,
  0xe5,
  0x43,
  0x28,
  0x95,
  0xfe,
  0xe8,
  0x83,
  0x3e,
  0x55,
  0x12,
  0x79,
  0xc4,
  0xaf,
  0xb9,
  0xd2,
  0x6f,
  0x04,
  0xe1,
  0x8a,
  0x37,
  0x5c,
  0x4a,
  0x21,
  0x9c,
  0xf7,
  0xb0,
  0xdb,
  0x66,
  0x0d,
  0x1b,
  0x70,
  0xcd,
  0xa6,
  0x86,
  0xed,
  0x50,
  0x3b,
  0x2d,
  0x46,
  0xfb,
  0x90,
  0xd7,
  0xbc,
  0x01,
  0x6a,
  0x7c,
  0x17,
  0xaa,
  0xc1,
  0x24,
  0x4f,
  0xf2,
  0x99,
  0x8f,
  0xe4,
  0x59,
  0x32,
  0x75,
  0x1e,
  0xa3,
  0xc8,
  0xde,
  0xb5,
  0x08,
  0x63,
  0xc5,
  0xae,
  0x13,
  0x78,
  0x6e,
  0x05,
  0xb8,
  0xd3,
  0x94,
  0xff,
  0x42,
  0x29,
  0x3f,
  0x54,
  0xe9,
  0x82,
  0x67,
  0x0c,
  0xb1,
  0xda,
  0xcc,
  0xa7,
  0x1a,
  0x71,
  0x36,
  0x5d,
  0xe0,
  0x8b,
  0x9d,
  0xf6,
  0x4b,
  0x20,
  0x0b,
  0x60,
  0xdd,
  0xb6,
  0xa0,
  0xcb,
  0x76,
  0x1d,
  0x5a,
  0x31,
  0x8c,
  0xe7,
  0xf1,
  0x9a,
  0x27,
  0x4c,
  0xa9,
  0xc2,
  0x7f,
  0x14,
  0x02,
  0x69,
  0xd4,
  0xbf,
  0xf8,
  0x93,
  0x2e,
  0x45,
  0x53,
  0x38,
  0x85,
  0xee,
  0x48,
  0x23,
  0x9e,
  0xf5,
  0xe3,
  0x88,
  0x35,
  0x5e,
  0x19,
  0x72,
  0xcf,
  0xa4,
  0xb2,
  0xd9,
  0x64,
  0x0f,
  0xea,
  0x81,
  0x3c,
  0x57,
  0x41,
  0x2a,
  0x97,
  0xfc,
  0xbb,
  0xd0,
  0x6d,
  0x06,
  0x10,
  0x7b,
  0xc6,
  0xad,
  0x8d,
  0xe6,
  0x5b,
  0x30,
  0x26,
  0x4d,
  0xf0,
  0x9b,
  0xdc,
  0xb7,
  0x0a,
  0x61,
  0x77,
  0x1c,
  0xa1,
  0xca,
  0x2f,
  0x44,
  0xf9,
  0x92,
  0x84,
  0xef,
  0x52,
  0x39,
  0x7e,
  0x15,
  0xa8,
  0xc3,
  0xd5,
  0xbe,
  0x03,
  0x68,
  0xce,
  0xa5,
  0x18,
  0x73,
  0x65,
  0x0e,
  0xb3,
  0xd8,
  0x9f,
  0xf4,
  0x49,
  0x22,
  0x34,
  0x5f,
  0xe2,
  0x89,
  0x6c,
  0x07,
  0xba,
  0xd1,
  0xc7,
  0xac,
  0x11,
  0x7a,
  0x3d,
  0x56,
  0xeb,
  0x80,
  0x96,
  0xfd,
  0x40,
  0x2b,
  0x00,
  0x16,
  0x2c,
  0x3a,
  0x58,
  0x4e,
  0x74,
  0x62,
  0xb0,
  0xa6,
  0x9c,
  0x8a,
  0xe8,
  0xfe,
  0xc4,
  0xd2,
  0x67,
  0x71,
  0x4b,
  0x5d,
  0x3f,
  0x29,
  0x13,
  0x05,
  0xd7,
  0xc1,
  0xfb,
  0xed,
  0x8f,
  0x99,
  0xa3,
  0xb5,
  0xce,
  0xd8,
  0xe2,
  0xf4,
  0x96,
  0x80,
  0xba,
  0xac,
  0x7e,
  0x68,
  0x52,
  0x44,
  0x26,
  0x30,
  0x0a,
  0x1c,
  0xa9,
  0xbf,
  0x85,
  0x93,
  0xf1,
  0xe7,
  0xdd,
  0xcb,
  0x19,
  0x0f,
  0x35,
  0x23,
  0x41,
  0x57,
  0x6d,
  0x7b,
  0x9b,
  0x8d,
  0xb7,
  0xa1,
  0xc3,
  0xd5,
  0xef,
  0xf9,
  0x2b,
  0x3d,
  0x07,
  0x11,
  0x73,
  0x65,
  0x5f,
  0x49,
  0xfc,
  0xea,
  0xd0,
  0xc6,
  0xa4,
  0xb2,
  0x88,
  0x9e,
  0x4c,
  0x5a,
  0x60,
  0x76,
  0x14,
  0x02,
  0x38,
  0x2e,
  0x55,
  0x43,
  0x79,
  0x6f,
  0x0d,
  0x1b,
  0x21,
  0x37,
  0xe5,
  0xf3,
  0xc9,
  0xdf,
  0xbd,
  0xab,
  0x91,
  0x87,
  0x32,
  0x24,
  0x1e,
  0x08,
  0x6a,
  0x7c,
  0x46,
  0x50,
  0x82,
  0x94,
  0xae,
  0xb8,
  0xda,
  0xcc,
  0xf6,
  0xe0,
  0x31,
  0x27,
  0x1d,
  0x0b,
  0x69,
  0x7f,
  0x45,
  0x53,
  0x81,
  0x97,
  0xad,
  0xbb,
  0xd9,
  0xcf,
  0xf5,
  0xe3,
  0x56,
  0x40,
  0x7a,
  0x6c,
  0x0e,
  0x18,
  0x22,
  0x34,
  0xe6,
  0xf0,
  0xca,
  0xdc,
  0xbe,
  0xa8,
  0x92,
  0x84,
  0xff,
  0xe9,
  0xd3,
  0xc5,
  0xa7,
  0xb1,
  0x8b,
  0x9d,
  0x4f,
  0x59,
  0x63,
  0x75,
  0x17,
  0x01,
  0x3b,
  0x2d,
  0x98,
  0x8e,
  0xb4,
  0xa2,
  0xc0,
  0xd6,
  0xec,
  0xfa,
  0x28,
  0x3e,
  0x04,
  0x12,
  0x70,
  0x66,
  0x5c,
  0x4a,
  0xaa,
  0xbc,
  0x86,
  0x90,
  0xf2,
  0xe4,
  0xde,
  0xc8,
  0x1a,
  0x0c,
  0x36,
  0x20,
  0x42,
  0x54,
  0x6e,
  0x78,
  0xcd,
  0xdb,
  0xe1,
  0xf7,
  0x95,
  0x83,
  0xb9,
  0xaf,
  0x7d,
  0x6b,
  0x51,
  0x47,
  0x25,
  0x33,
  0x09,
  0x1f,
  0x64,
  0x72,
  0x48,
  0x5e,
  0x3c,
  0x2a,
  0x10,
  0x06,
  0xd4,
  0xc2,
  0xf8,
  0xee,
  0x8c,
  0x9a,
  0xa0,
  0xb6,
  0x03,
  0x15,
  0x2f,
  0x39,
  0x5b,
  0x4d,
  0x77,
  0x61,
  0xb3,
  0xa5,
  0x9f,
  0x89,
  0xeb,
  0xfd,
  0xc7,
  0xd1,
];


const crc_table_16 = [
  0x0000,
  0x0580,
  0x0f80,
  0x0a00,
  0x1b80,
  0x1e00,
  0x1400,
  0x1180,
  0x3380,
  0x3600,
  0x3c00,
  0x3980,
  0x2800,
  0x2d80,
  0x2780,
  0x2200,
  0x6380,
  0x6600,
  0x6c00,
  0x6980,
  0x7800,
  0x7d80,
  0x7780,
  0x7200,
  0x5000,
  0x5580,
  0x5f80,
  0x5a00,
  0x4b80,
  0x4e00,
  0x4400,
  0x4180,
  0xc380,
  0xc600,
  0xcc00,
  0xc980,
  0xd800,
  0xdd80,
  0xd780,
  0xd200,
  0xf000,
  0xf580,
  0xff80,
  0xfa00,
  0xeb80,
  0xee00,
  0xe400,
  0xe180,
  0xa000,
  0xa580,
  0xaf80,
  0xaa00,
  0xbb80,
  0xbe00,
  0xb400,
  0xb180,
  0x9380,
  0x9600,
  0x9c00,
  0x9980,
  0x8800,
  0x8d80,
  0x8780,
  0x8200,
  0x8381,
  0x8601,
  0x8c01,
  0x8981,
  0x9801,
  0x9d81,
  0x9781,
  0x9201,
  0xb001,
  0xb581,
  0xbf81,
  0xba01,
  0xab81,
  0xae01,
  0xa401,
  0xa181,
  0xe001,
  0xe581,
  0xef81,
  0xea01,
  0xfb81,
  0xfe01,
  0xf401,
  0xf181,
  0xd381,
  0xd601,
  0xdc01,
  0xd981,
  0xc801,
  0xcd81,
  0xc781,
  0xc201,
  0x4001,
  0x4581,
  0x4f81,
  0x4a01,
  0x5b81,
  0x5e01,
  0x5401,
  0x5181,
  0x7381,
  0x7601,
  0x7c01,
  0x7981,
  0x6801,
  0x6d81,
  0x6781,
  0x6201,
  0x2381,
  0x2601,
  0x2c01,
  0x2981,
  0x3801,
  0x3d81,
  0x3781,
  0x3201,
  0x1001,
  0x1581,
  0x1f81,
  0x1a01,
  0x0b81,
  0x0e01,
  0x0401,
  0x0181,
  0x0383,
  0x0603,
  0x0c03,
  0x0983,
  0x1803,
  0x1d83,
  0x1783,
  0x1203,
  0x3003,
  0x3583,
  0x3f83,
  0x3a03,
  0x2b83,
  0x2e03,
  0x2403,
  0x2183,
  0x6003,
  0x6583,
  0x6f83,
  0x6a03,
  0x7b83,
  0x7e03,
  0x7403,
  0x7183,
  0x5383,
  0x5603,
  0x5c03,
  0x5983,
  0x4803,
  0x4d83,
  0x4783,
  0x4203,
  0xc003,
  0xc583,
  0xcf83,
  0xca03,
  0xdb83,
  0xde03,
  0xd403,
  0xd183,
  0xf383,
  0xf603,
  0xfc03,
  0xf983,
  0xe803,
  0xed83,
  0xe783,
  0xe203,
  0xa383,
  0xa603,
  0xac03,
  0xa983,
  0xb803,
  0xbd83,
  0xb783,
  0xb203,
  0x9003,
  0x9583,
  0x9f83,
  0x9a03,
  0x8b83,
  0x8e03,
  0x8403,
  0x8183,
  0x8002,
  0x8582,
  0x8f82,
  0x8a02,
  0x9b82,
  0x9e02,
  0x9402,
  0x9182,
  0xb382,
  0xb602,
  0xbc02,
  0xb982,
  0xa802,
  0xad82,
  0xa782,
  0xa202,
  0xe382,
  0xe602,
  0xec02,
  0xe982,
  0xf802,
  0xfd82,
  0xf782,
  0xf202,
  0xd002,
  0xd582,
  0xdf82,
  0xda02,
  0xcb82,
  0xce02,
  0xc402,
  0xc182,
  0x4382,
  0x4602,
  0x4c02,
  0x4982,
  0x5802,
  0x5d82,
  0x5782,
  0x5202,
  0x7002,
  0x7582,
  0x7f82,
  0x7a02,
  0x6b82,
  0x6e02,
  0x6402,
  0x6182,
  0x2002,
  0x2582,
  0x2f82,
  0x2a02,
  0x3b82,
  0x3e02,
  0x3402,
  0x3182,
  0x1382,
  0x1602,
  0x1c02,
  0x1982,
  0x0802,
  0x0d82,
  0x0782,
  0x0202,
  0x0000,
  0x0386,
  0x038c,
  0x000a,
  0x0398,
  0x001e,
  0x0014,
  0x0392,
  0x03b0,
  0x0036,
  0x003c,
  0x03ba,
  0x0028,
  0x03ae,
  0x03a4,
  0x0022,
  0x03e0,
  0x0066,
  0x006c,
  0x03ea,
  0x0078,
  0x03fe,
  0x03f4,
  0x0072,
  0x0050,
  0x03d6,
  0x03dc,
  0x005a,
  0x03c8,
  0x004e,
  0x0044,
  0x03c2,
  0x0340,
  0x00c6,
  0x00cc,
  0x034a,
  0x00d8,
  0x035e,
  0x0354,
  0x00d2,
  0x00f0,
  0x0376,
  0x037c,
  0x00fa,
  0x0368,
  0x00ee,
  0x00e4,
  0x0362,
  0x00a0,
  0x0326,
  0x032c,
  0x00aa,
  0x0338,
  0x00be,
  0x00b4,
  0x0332,
  0x0310,
  0x0096,
  0x009c,
  0x031a,
  0x0088,
  0x030e,
  0x0304,
  0x0082,
  0x0680,
  0x0506,
  0x050c,
  0x068a,
  0x0518,
  0x069e,
  0x0694,
  0x0512,
  0x0530,
  0x06b6,
  0x06bc,
  0x053a,
  0x06a8,
  0x052e,
  0x0524,
  0x06a2,
  0x0560,
  0x06e6,
  0x06ec,
  0x056a,
  0x06f8,
  0x057e,
  0x0574,
  0x06f2,
  0x06d0,
  0x0556,
  0x055c,
  0x06da,
  0x0548,
  0x06ce,
  0x06c4,
  0x0542,
  0x05c0,
  0x0646,
  0x064c,
  0x05ca,
  0x0658,
  0x05de,
  0x05d4,
  0x0652,
  0x0670,
  0x05f6,
  0x05fc,
  0x067a,
  0x05e8,
  0x066e,
  0x0664,
  0x05e2,
  0x0620,
  0x05a6,
  0x05ac,
  0x062a,
  0x05b8,
  0x063e,
  0x0634,
  0x05b2,
  0x0590,
  0x0616,
  0x061c,
  0x059a,
  0x0608,
  0x058e,
  0x0584,
  0x0602,
  0x0980,
  0x0a06,
  0x0a0c,
  0x098a,
  0x0a18,
  0x099e,
  0x0994,
  0x0a12,
  0x0a30,
  0x09b6,
  0x09bc,
  0x0a3a,
  0x09a8,
  0x0a2e,
  0x0a24,
  0x09a2,
  0x0a60,
  0x09e6,
  0x09ec,
  0x0a6a,
  0x09f8,
  0x0a7e,
  0x0a74,
  0x09f2,
  0x09d0,
  0x0a56,
  0x0a5c,
  0x09da,
  0x0a48,
  0x09ce,
  0x09c4,
  0x0a42,
  0x0ac0,
  0x0946,
  0x094c,
  0x0aca,
  0x0958,
  0x0ade,
  0x0ad4,
  0x0952,
  0x0970,
  0x0af6,
  0x0afc,
  0x097a,
  0x0ae8,
  0x096e,
  0x0964,
  0x0ae2,
  0x0920,
  0x0aa6,
  0x0aac,
  0x092a,
  0x0ab8,
  0x093e,
  0x0934,
  0x0ab2,
  0x0a90,
  0x0916,
  0x091c,
  0x0a9a,
  0x0908,
  0x0a8e,
  0x0a84,
  0x0902,
  0x0f00,
  0x0c86,
  0x0c8c,
  0x0f0a,
  0x0c98,
  0x0f1e,
  0x0f14,
  0x0c92,
  0x0cb0,
  0x0f36,
  0x0f3c,
  0x0cba,
  0x0f28,
  0x0cae,
  0x0ca4,
  0x0f22,
  0x0ce0,
  0x0f66,
  0x0f6c,
  0x0cea,
  0x0f78,
  0x0cfe,
  0x0cf4,
  0x0f72,
  0x0f50,
  0x0cd6,
  0x0cdc,
  0x0f5a,
  0x0cc8,
  0x0f4e,
  0x0f44,
  0x0cc2,
  0x0c40,
  0x0fc6,
  0x0fcc,
  0x0c4a,
  0x0fd8,
  0x0c5e,
  0x0c54,
  0x0fd2,
  0x0ff0,
  0x0c76,
  0x0c7c,
  0x0ffa,
  0x0c68,
  0x0fee,
  0x0fe4,
  0x0c62,
  0x0fa0,
  0x0c26,
  0x0c2c,
  0x0faa,
  0x0c38,
  0x0fbe,
  0x0fb4,
  0x0c32,
  0x0c10,
  0x0f96,
  0x0f9c,
  0x0c1a,
  0x0f88,
  0x0c0e,
  0x0c04,
  0x0f82,
  0x0000,
  0x1780,
  0x2b80,
  0x3c00,
  0x5380,
  0x4400,
  0x7800,
  0x6f80,
  0xa380,
  0xb400,
  0x8800,
  0x9f80,
  0xf000,
  0xe780,
  0xdb80,
  0xcc00,
  0x4381,
  0x5401,
  0x6801,
  0x7f81,
  0x1001,
  0x0781,
  0x3b81,
  0x2c01,
  0xe001,
  0xf781,
  0xcb81,
  0xdc01,
  0xb381,
  0xa401,
  0x9801,
  0x8f81,
  0x8382,
  0x9402,
  0xa802,
  0xbf82,
  0xd002,
  0xc782,
  0xfb82,
  0xec02,
  0x2002,
  0x3782,
  0x0b82,
  0x1c02,
  0x7382,
  0x6402,
  0x5802,
  0x4f82,
  0xc003,
  0xd783,
  0xeb83,
  0xfc03,
  0x9383,
  0x8403,
  0xb803,
  0xaf83,
  0x6383,
  0x7403,
  0x4803,
  0x5f83,
  0x3003,
  0x2783,
  0x1b83,
  0x0c03,
  0x0385,
  0x1405,
  0x2805,
  0x3f85,
  0x5005,
  0x4785,
  0x7b85,
  0x6c05,
  0xa005,
  0xb785,
  0x8b85,
  0x9c05,
  0xf385,
  0xe405,
  0xd805,
  0xcf85,
  0x4004,
  0x5784,
  0x6b84,
  0x7c04,
  0x1384,
  0x0404,
  0x3804,
  0x2f84,
  0xe384,
  0xf404,
  0xc804,
  0xdf84,
  0xb004,
  0xa784,
  0x9b84,
  0x8c04,
  0x8007,
  0x9787,
  0xab87,
  0xbc07,
  0xd387,
  0xc407,
  0xf807,
  0xef87,
  0x2387,
  0x3407,
  0x0807,
  0x1f87,
  0x7007,
  0x6787,
  0x5b87,
  0x4c07,
  0xc386,
  0xd406,
  0xe806,
  0xff86,
  0x9006,
  0x8786,
  0xbb86,
  0xac06,
  0x6006,
  0x7786,
  0x4b86,
  0x5c06,
  0x3386,
  0x2406,
  0x1806,
  0x0f86,
  0x038a,
  0x140a,
  0x280a,
  0x3f8a,
  0x500a,
  0x478a,
  0x7b8a,
  0x6c0a,
  0xa00a,
  0xb78a,
  0x8b8a,
  0x9c0a,
  0xf38a,
  0xe40a,
  0xd80a,
  0xcf8a,
  0x400b,
  0x578b,
  0x6b8b,
  0x7c0b,
  0x138b,
  0x040b,
  0x380b,
  0x2f8b,
  0xe38b,
  0xf40b,
  0xc80b,
  0xdf8b,
  0xb00b,
  0xa78b,
  0x9b8b,
  0x8c0b,
  0x8008,
  0x9788,
  0xab88,
  0xbc08,
  0xd388,
  0xc408,
  0xf808,
  0xef88,
  0x2388,
  0x3408,
  0x0808,
  0x1f88,
  0x7008,
  0x6788,
  0x5b88,
  0x4c08,
  0xc389,
  0xd409,
  0xe809,
  0xff89,
  0x9009,
  0x8789,
  0xbb89,
  0xac09,
  0x6009,
  0x7789,
  0x4b89,
  0x5c09,
  0x3389,
  0x2409,
  0x1809,
  0x0f89,
  0x000f,
  0x178f,
  0x2b8f,
  0x3c0f,
  0x538f,
  0x440f,
  0x780f,
  0x6f8f,
  0xa38f,
  0xb40f,
  0x880f,
  0x9f8f,
  0xf00f,
  0xe78f,
  0xdb8f,
  0xcc0f,
  0x438e,
  0x540e,
  0x680e,
  0x7f8e,
  0x100e,
  0x078e,
  0x3b8e,
  0x2c0e,
  0xe00e,
  0xf78e,
  0xcb8e,
  0xdc0e,
  0xb38e,
  0xa40e,
  0x980e,
  0x8f8e,
  0x838d,
  0x940d,
  0xa80d,
  0xbf8d,
  0xd00d,
  0xc78d,
  0xfb8d,
  0xec0d,
  0x200d,
  0x378d,
  0x0b8d,
  0x1c0d,
  0x738d,
  0x640d,
  0x580d,
  0x4f8d,
  0xc00c,
  0xd78c,
  0xeb8c,
  0xfc0c,
  0x938c,
  0x840c,
  0xb80c,
  0xaf8c,
  0x638c,
  0x740c,
  0x480c,
  0x5f8c,
  0x300c,
  0x278c,
  0x1b8c,
  0x0c0c,
  0x0000,
  0x0394,
  0x03a8,
  0x003c,
  0x03d0,
  0x0044,
  0x0078,
  0x03ec,
  0x0320,
  0x00b4,
  0x0088,
  0x031c,
  0x00f0,
  0x0364,
  0x0358,
  0x00cc,
  0x0640,
  0x05d4,
  0x05e8,
  0x067c,
  0x0590,
  0x0604,
  0x0638,
  0x05ac,
  0x0560,
  0x06f4,
  0x06c8,
  0x055c,
  0x06b0,
  0x0524,
  0x0518,
  0x068c,
  0x0c80,
  0x0f14,
  0x0f28,
  0x0cbc,
  0x0f50,
  0x0cc4,
  0x0cf8,
  0x0f6c,
  0x0fa0,
  0x0c34,
  0x0c08,
  0x0f9c,
  0x0c70,
  0x0fe4,
  0x0fd8,
  0x0c4c,
  0x0ac0,
  0x0954,
  0x0968,
  0x0afc,
  0x0910,
  0x0a84,
  0x0ab8,
  0x092c,
  0x09e0,
  0x0a74,
  0x0a48,
  0x09dc,
  0x0a30,
  0x09a4,
  0x0998,
  0x0a0c,
  0x1d80,
  0x1e14,
  0x1e28,
  0x1dbc,
  0x1e50,
  0x1dc4,
  0x1df8,
  0x1e6c,
  0x1ea0,
  0x1d34,
  0x1d08,
  0x1e9c,
  0x1d70,
  0x1ee4,
  0x1ed8,
  0x1d4c,
  0x1bc0,
  0x1854,
  0x1868,
  0x1bfc,
  0x1810,
  0x1b84,
  0x1bb8,
  0x182c,
  0x18e0,
  0x1b74,
  0x1b48,
  0x18dc,
  0x1b30,
  0x18a4,
  0x1898,
  0x1b0c,
  0x1100,
  0x1294,
  0x12a8,
  0x113c,
  0x12d0,
  0x1144,
  0x1178,
  0x12ec,
  0x1220,
  0x11b4,
  0x1188,
  0x121c,
  0x11f0,
  0x1264,
  0x1258,
  0x11cc,
  0x1740,
  0x14d4,
  0x14e8,
  0x177c,
  0x1490,
  0x1704,
  0x1738,
  0x14ac,
  0x1460,
  0x17f4,
  0x17c8,
  0x145c,
  0x17b0,
  0x1424,
  0x1418,
  0x178c,
  0x3f80,
  0x3c14,
  0x3c28,
  0x3fbc,
  0x3c50,
  0x3fc4,
  0x3ff8,
  0x3c6c,
  0x3ca0,
  0x3f34,
  0x3f08,
  0x3c9c,
  0x3f70,
  0x3ce4,
  0x3cd8,
  0x3f4c,
  0x39c0,
  0x3a54,
  0x3a68,
  0x39fc,
  0x3a10,
  0x3984,
  0x39b8,
  0x3a2c,
  0x3ae0,
  0x3974,
  0x3948,
  0x3adc,
  0x3930,
  0x3aa4,
  0x3a98,
  0x390c,
  0x3300,
  0x3094,
  0x30a8,
  0x333c,
  0x30d0,
  0x3344,
  0x3378,
  0x30ec,
  0x3020,
  0x33b4,
  0x3388,
  0x301c,
  0x33f0,
  0x3064,
  0x3058,
  0x33cc,
  0x3540,
  0x36d4,
  0x36e8,
  0x357c,
  0x3690,
  0x3504,
  0x3538,
  0x36ac,
  0x3660,
  0x35f4,
  0x35c8,
  0x365c,
  0x35b0,
  0x3624,
  0x3618,
  0x358c,
  0x2200,
  0x2194,
  0x21a8,
  0x223c,
  0x21d0,
  0x2244,
  0x2278,
  0x21ec,
  0x2120,
  0x22b4,
  0x2288,
  0x211c,
  0x22f0,
  0x2164,
  0x2158,
  0x22cc,
  0x2440,
  0x27d4,
  0x27e8,
  0x247c,
  0x2790,
  0x2404,
  0x2438,
  0x27ac,
  0x2760,
  0x24f4,
  0x24c8,
  0x275c,
  0x24b0,
  0x2724,
  0x2718,
  0x248c,
  0x2e80,
  0x2d14,
  0x2d28,
  0x2ebc,
  0x2d50,
  0x2ec4,
  0x2ef8,
  0x2d6c,
  0x2da0,
  0x2e34,
  0x2e08,
  0x2d9c,
  0x2e70,
  0x2de4,
  0x2dd8,
  0x2e4c,
  0x28c0,
  0x2b54,
  0x2b68,
  0x28fc,
  0x2b10,
  0x2884,
  0x28b8,
  0x2b2c,
  0x2be0,
  0x2874,
  0x2848,
  0x2bdc,
  0x2830,
  0x2ba4,
  0x2b98,
  0x280c,
];


function get_crc(crc_table: number[], buffer: number[]): number {
  let pos = 0;
  let crc = 0;
  while (pos < buffer.length) {
    crc = crc_table[(crc & 0xFF) ^ buffer[pos]] ^ (crc >>> 8);
    pos++;
  }
  return crc;
}


export function get_crc_8bits(buffer: number[]): number {
  return get_crc(crc_table_8, buffer);
}


export function get_crc_16bits(buffer: number[]): number {
  const crc = get_crc(crc_table_16, buffer);

  // When we are done, we need to swap the bytes
  const a = (crc & 0xFF00) >> 8;
  const b = (crc & 0xFF);
  return (b << 8) | a;
}
